<div class="container-box manage-user">
  <!-- <app-breadcrumb [breadCrumbs]="breadCrumbs"></app-breadcrumb> -->
  <!-- <h1>Assign or un-assign licenses</h1>-->
  <h1>{{title}}</h1>
  <app-stepindicator [stepIndicators]="steps" [sessionName]="stepSessionName"></app-stepindicator>
  <router-outlet></router-outlet>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>